/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	UpdateSpaceRoleAssignmentsMutation$data as UpdateSpaceRoleAssignmentsMutation,
	UpdateSpaceRoleAssignmentsMutation$variables as UpdateSpaceRoleAssignmentsMutationVariables,
} from '../__generated__/UpdateSpaceRoleAssignmentsMutation.graphql.ts';

// Nested types extracted from Relay-generated types
import type { UpdateSpaceRoleAssignmentsMutation$data } from '../__generated__/UpdateSpaceRoleAssignmentsMutation.graphql.ts';
export type UpdateSpaceRoleAssignmentsMutation_setSpaceRoleAssignments_errors_extensions = NonNullable<NonNullable<NonNullable<NonNullable<UpdateSpaceRoleAssignmentsMutation$data['setSpaceRoleAssignments']>['errors']>[number]>['extensions']>;
export type UpdateSpaceRoleAssignmentsMutation_setSpaceRoleAssignments_errors = NonNullable<NonNullable<NonNullable<UpdateSpaceRoleAssignmentsMutation$data['setSpaceRoleAssignments']>['errors']>[number]>;
export type UpdateSpaceRoleAssignmentsMutation_setSpaceRoleAssignments = NonNullable<UpdateSpaceRoleAssignmentsMutation$data['setSpaceRoleAssignments']>;

// GraphQL input types re-exported from Relay artifact
export type { RoleAssignment, RoleAssignmentPrincipalInput, SetSpaceRoleAssignmentsInput } from '../__generated__/UpdateSpaceRoleAssignmentsMutation.graphql.ts';

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum RoleAssignmentPrincipalType {
  ACCESS_CLASS = "ACCESS_CLASS",
  APP = "APP",
  GROUP = "GROUP",
  USER = "USER",
}

